var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ReceiptsApi } from '@ClientServices/api/receiptsApi';
export const SET_RECEIPTS = 'SET_RECEIPTS';
export const SET_RECEIPTS_LOADING = 'SET_RECEIPTS_LOADING';
export const SET_SKIPPED_RECEIPTS = 'SET_SKIPPED_RECEIPTS';
export class SetReceipts {
    constructor(payload) {
        this.payload = payload;
        this.type = SET_RECEIPTS;
    }
}
export class SetReceiptsLoading {
    constructor(payload) {
        this.payload = payload;
        this.type = SET_RECEIPTS_LOADING;
    }
}
export class SetSkippedReceipts {
    constructor(payload) {
        this.payload = payload;
        this.type = SET_SKIPPED_RECEIPTS;
    }
}
export const getReceipts = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(new SetReceiptsLoading(true));
    const receipts = yield ReceiptsApi.getAll();
    dispatch(new SetReceipts(receipts));
});
